import React, {  useMemo } from "react";
import "./Metrics.css";
import NotificationExample from "../../../../components/Notification/notification";
import postureMetricsConfig from './posture-metrics-config.json'
import PropTypes from 'prop-types'; 
function PostureMetrics({ legends }) {


    // State to control which notification to show
    const [currentNotificationType, setCurrentNotificationType] = React.useState(null);
const getScoreCategory = (score) => {
  if (score >= 70) return "security-critical";
  if (score >= 40) return "security-moderate";
  return "security-good";
};

React.useEffect(() => {
  if (!legends || legends.length === 0) return setCurrentNotificationType(null);

  const plantScore = legends.find(
    (legend) => legend.metricName === postureMetricsConfig.plantSecurityScore.metricName
  );

  if (!plantScore) return setCurrentNotificationType(null);

  const score = parseFloat(plantScore.metricScore);
  if (isNaN(score)) return setCurrentNotificationType(null);

  setCurrentNotificationType(getScoreCategory(score));
}, [legends]);


    const renderMetrics = useMemo(() => {
        const renderMetric = (legend, index) => {
            let badgeClass = "";
            let statusText = "";

            if (legend.metricName === "Plant Security Score") {
                const score = parseFloat(legend.metricScore);
                if (!isNaN(score)) {
                    if (score >= 70) {
                         badgeClass = "badge-red";
                        statusText = postureMetricsConfig.statusText.textCritical;
                    } else if (score >= 40) {
                        badgeClass = "badge-orange";
                        statusText = postureMetricsConfig.statusText.textModerate;
                    } else {
                       
                        badgeClass = "badge-green";
                        statusText = postureMetricsConfig.statusText.textGood;
                    }
                }
            }



            return (
                <div id="posture-dashboard-metrics" key={index}>
                    <span className="metric-name">{legend.metricName}</span>
                    <div id="metrics-details">
                        <span className="metric-score">
                            {legend.metricScore}
                            {legend.metricStat && (
                                <span style={{ lineHeight: "24px" }} className="metric-unit">
                                    &nbsp;&nbsp;{legend.metricStat}
                                </span>
                            )}
                            {statusText && (
                                <span className="status-wrapper" style={{ marginLeft: "50px", position: 'relative' }}>
                                    <span className={badgeClass}>
                                        {statusText}
                                    </span>
                                    {/* The NotificationExample component will handle displaying the notification */}
                                </span>
                            )}
                        </span>
                    </div>
                </div>
            );
        };

        return legends?.map((legend, index) => renderMetric(legend, index));
    }, [legends]);

    return (
      
        <div className="posture-metrics-box" >
            {renderMetrics}
            {/* Render NotificationExample with the determined notitype */}
            {currentNotificationType && <NotificationExample notitype={currentNotificationType} />}
        </div>
    );
}

PostureMetrics.propTypes = {
    legends: PropTypes.arrayOf(
        PropTypes.shape({
            metricName: PropTypes.string.isRequired,
            metricScore: PropTypes.string.isRequired,
            metricStat: PropTypes.string
        })
    ).isRequired
};


export default PostureMetrics;